import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'grid-pagination',
    templateUrl: './grid-pagination.component.html',
    styleUrls: ['./grid-pagination.component.scss']
  })
  export class GridPaginationComponent  {
    @Input() hideGrid!: boolean;
    @Input() currentPage: any;
    @Output("pageNavigationClicked") pageNavigationClicked: EventEmitter<any> = new EventEmitter();
    public firstContainer: Array<number> = [];
  public secondContainer: Array<number> = [];
  public thirdContainer: Array<number> = [];
  public finalPaginationContainer: Array<any> = [];

    callParentPageNavigation(page: any){
        this.pageNavigationClicked.emit(page);
    }

    
  public arrangePaginationObjectsForUnderflow(lastPage: number) {
    this.emptyPaginationContainers();
    this.firstContainer.push(0);
    for (let index = 1; index <= lastPage; index++) {
      this.firstContainer.push(index);
    }
    this.firstContainer.push(3.14);
    this.finalPaginationContainer = [...this.firstContainer];
  }

  public arrangePaginationObjectsForOverflow(pageSelected: number, lastPage: number) {
    this.emptyPaginationContainers();
    this.firstContainer.push(0);
    if (pageSelected <= 4 || pageSelected >= lastPage - 3) {
      //lies in either of the boundary

      for (let index = 1; index <= 4; index++) {
        this.firstContainer.push(index)
        this.thirdContainer.push(lastPage - index + 1);
      }
      this.secondContainer.push(-1);
    } else {
      //lies in the middle portion
      this.firstContainer.push(1);
      this.thirdContainer.push(lastPage);
      this.secondContainer.push(-1);
      for (let index = pageSelected - 2; index < pageSelected + 3; index++) {
        this.secondContainer.push(index);
      }
      this.secondContainer.push(-1);
    }
    this.thirdContainer.sort((a, b) => (a - b));
    this.thirdContainer.push(3.14);
    this.finalPaginationContainer = [...this.firstContainer, ...this.secondContainer, ...this.thirdContainer];
  }
  public emptyPaginationContainers() {
    this.firstContainer = [];
    this.secondContainer = [];
    this.thirdContainer = [];
    this.finalPaginationContainer = [];
  }
  public renderPaginationControl(currentPage: number, totalPages: number){
    if (!this.finalPaginationContainer.includes(currentPage)) {
        //dont re render the pagination control
        if (totalPages >= 8) {
          //Equal to or more than 8 pages.
          this.arrangePaginationObjectsForOverflow(currentPage + 1, totalPages)
        }
        else {
          // less than 8 pages.
          this.arrangePaginationObjectsForUnderflow(totalPages);
        }
      }
      else{
        this.arrangePaginationObjectsForUnderflow(totalPages);
      }
  }

  }